// @ts-strict-ignore
import React from 'react'
import { hydrate } from 'react-dom'
import { loadableReady } from '@loadable/component'
import App from './app'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'

const cache = createCache({ key: 'ev' })

loadableReady(() => {
  hydrate(
    <CacheProvider value={cache}>
      <App evCoreState={window.__initialState__.evCoreState} />
    </CacheProvider>,
    document.getElementById('app'),
  )
})

if (module.hot) {
  module.hot.accept()
}
